import { Controller } from "@hotwired/stimulus"

// A recurring task's day-of-week only means something for a weekly cadence.
export default class extends Controller {
    static targets = ["cadence", "day"]

    connect() { this.toggle() }

    toggle() {
        this.dayTarget.hidden = this.cadenceTarget.value !== "weekly"
    }
}
